import { createRouter, createWebHistory } from "vue-router";
import Index from "../views/Index.vue";
import ClienteDashboard from "@/views/Clientes/ClienteDashboard.vue";
import TrasladosDisponibles from "@/views/Clientes/TrasladosDisponibles.vue";
import ConfReserva from "@/views/Clientes/ConfReserva.vue";
import FinalView from "@/views/Clientes/FinalView.vue";
import AdminDashboard from "../views/Admin/AdminDashboard.vue";
import EmpleadoDashboard from "../views/Empleado/EmpleadoDashboard.vue";
import RegistroConductores from "../views/Admin/RegistroConductores.vue";
import RegistroUsuarios from "../views/Admin/RegistroUsuarios.vue";
import RegistroAutos from "../views/Admin/RegistroAutos.vue";
import RegistroPagos from "@/views/Admin/RegistroPagos.vue";
import AdminHome from "../views/Admin/AdminHome.vue";
import RegistroTarifa from "@/views/Admin/RegistroTarifa.vue";
import RegistroReservaciones from "@/views/Admin/RegistroReservaciones.vue";
import ReservacionesEmpleado from "@/views/Empleado/ReservacionesEmpleado.vue";
import ConductoresEmpleado from "@/views/Empleado/ConductoresEmpleado.vue";
import AutosEmpleado from "@/views/Empleado/AutosEmpleado.vue";
import PagosEmpleado from "@/views/Empleado/PagosEmpleado.vue";
import PerfilUsuario from "@/components/PerfilUsuario.vue";
import ReporteReservaciones from "@/components/ReporteReservaciones.vue";
import RegistroUbicaciones from "@/views/Admin/RegistroUbicaciones.vue";
import PanelEmpleado from "@/views/Empleado/PanelEmpleado.vue";
import ConfiguracionParametros from "@/views/Admin/ConfiguracionParametros.vue";
import DatosBanco from "@/views/Admin/DatosBanco.vue";
import RecuperacionContraseña from "@/components/RecuperacionContrasena.vue";


const routes = [
  { path: "/", name: "ClienteDashboard", component: ClienteDashboard },
  { path: "/TrasladosDisponibles", name: "TrasladosDisponibles", component: TrasladosDisponibles },
  { path: "/Confirmacion", name: "ConfReserva", component: ConfReserva },
  { path: "/RecuperacionContrasena", name: "RecuperacionContraseña", component: RecuperacionContraseña },
  { path: "/Final", name: "FinalView", component: FinalView },
  { path: "/InicioSesion", name: "Index", component: Index },
  { path: "/NuevaContrasena", name: "NuevaContrasena", component: () => import('@/components/NuevaContrasena.vue'),}, // Corrección aquí
  {
    path: "/Admin",
    name: "AdminDashboard",
    component: AdminDashboard,
    redirect: "/Admin/Home",
    meta: { requiresAuth: true },
    children: [
      { path: "Home", component: AdminHome },
      { path: "usuarios", component: RegistroUsuarios },
      { path: "autos", component: RegistroAutos },
      { path: "conductores", component: RegistroConductores },
      { path: "pago", component: RegistroPagos },
      { path: "tarifa", component: RegistroTarifa },
      { path: "reservaciones", component: RegistroReservaciones },
      { path: "ubicaciones", component: RegistroUbicaciones },
      { path: "parametros", component: ConfiguracionParametros },
      { path: "banco", component: DatosBanco },
      { path: "perfil", name: "AdminPerfil", component: PerfilUsuario },
      { path: "reporte", name: "AdminReporte", component: ReporteReservaciones },
    ],
  },
  {
    path: "/Empleado",
    name: "EmpleadoDashboard",
    component: EmpleadoDashboard,
    redirect: "/Empleado/panelEmpl",
    meta: { requiresAuth: true },
    children: [
      { path: "panelEmpl", component: PanelEmpleado },
      { path: "reporte", name: "EmpleadoReporte", component: ReporteReservaciones },
      { path: "conductores", component: ConductoresEmpleado },
      { path: "reservacion", component: ReservacionesEmpleado },
      { path: "autos", component: AutosEmpleado },
      { path: "pagos", component: PagosEmpleado },
      { path: "perfil", name: "EmpleadoPerfil", component: PerfilUsuario },
    ],
  },
  { path: "/:pathMatch(.*)*", redirect: "/" },
];


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const role = localStorage.getItem("role");
  const isAuthenticated = !!role;

  if (to.meta.requiresAuth) {
    if (!isAuthenticated) return next("/");
    if (to.path.startsWith("/Admin") && role !== "administrador") return next("/");
    if (to.path.startsWith("/Empleado") && role !== "empleado") return next("/");
  }
  next();
});

export default router;